import { Controller, useForm } from "react-hook-form"
import { Button } from "src/shared/components/forms"
import Dropdown from "src/shared/components/forms/selelct-dropdown/Dropdown"
import useSnackbar from "src/shared/hooks/useSnackbar"
import { Modal } from "src/shared/components/layout/modal/Modal"
import { Descuento, FilterDescuentos } from "./ModalDescuentos.type"
import { useOpcionesDescuentos } from "./hooks/useOpcionesDescuentos"
import { useStateDescuentos } from "./hooks/useStateDescuentos"
import "./ModalDescuentos.css"

type FormValues = {
    descuento_id: string
}

interface ModalDescuentosProps {
    title?: string
    description?: string
    onChange: (value: Descuento) => void
    onClose: () => void
    value: Descuento
    filter: FilterDescuentos
}

function ModalDescuentos({ title = "Descuentos de estancia", description = "Los descuentos se aplicarán al total de la estancia", value,  onClose, onChange, filter }: ModalDescuentosProps) {
    const { control, handleSubmit, watch, setError } = useForm<FormValues>({
        defaultValues: { descuento_id: value.descuento_id }
    })

    const descuento_seleccionado = watch("descuento_id")

    const { opciones_descuentos, loading } = useOpcionesDescuentos({ sin_vigencia: true, ...filter })

    const { showSnackbar } = useSnackbar()

    const isSelected = value.descuento_id
   

    const onSubmit = ({ descuento_id }: FormValues) => {
        if(value.descuento_id === descuento_id) {
            onClose()
            return
        }

        const find = opciones_descuentos.find((v)=>v.value === descuento_id)
        const nombre = find?.label?.split(" | ")?.[0] || ""
        
        if(!find) return

        const find_total = Number(find?.total || 0)
        const filter_total = Number(filter?.total || 0)
        
        if(filter_total > 0 && find_total >= filter_total) {
            setError("descuento_id", { message: "Este descuento excede el total de la cuenta. Elige otro para continuar." })
            return
        }
        
        if(!value.descuento_id) {
            showSnackbar({ title: "Descuento aplicado", text: `Se aplicó el descuento **${nombre}** a la estancia.`, status: "success" })
        } else {
            showSnackbar({ title: "Descuento editado", text: `Se editó el descuento **${nombre}** a la estancia.`, status: "success" })
        }

        onChange({ descuento_id: find?.value || "", total: find_total, nombre: find?.label?.split(" | ")?.[0] || "", tipo_descuento: find?.tipo_descuento, valor: find?.valor })
    }

    const onCancel = () => {
        showSnackbar({ title: "Descuento eliminado", text: `Se eliminó el descuento **${value.nombre}** de la estancia.`, status: "success" })
        onChange({ descuento_id: "", total: 0, nombre: "" })
    }

    return (
        <Modal isOpen={true} width={570} height={250} onClose={onClose} withCloseButton className="modal-descuentos">
            <p className="modal-descuentos__title">{title}</p>
            <p className="modal-descuentos__description">{description}</p>
            <form onSubmit={handleSubmit(onSubmit)} >
                <div className="modal-descuentos__form">
                    <Controller
                        control={control}
                        name={"descuento_id"}
                        rules={{ required: true }}
                        render={({ field: { value, onChange }, fieldState: { error } }) => (
                            <Dropdown
                                containerClassName="modal-descuentos__select"
                                icon={"priceTag"}
                                iconInOptions={false}
                                errorHintText={error ? error?.message || "Selecciona una opción" : ""}
                                label={"Descuento"}
                                placeholder={"Selecciona un tipo de descuento"}
                                options={opciones_descuentos}
                                value={value}
                                onClick={({ value }) => onChange(value)}
                                disabled={loading}
                            />
                        )}
                    />
                </div>
                <div className={`modal-descuentos__footer${isSelected ? " modal-descuentos__row" : ""}`}>
                    {isSelected && <Button className="modal-descuentos__btn" type={"button"} text={"Eliminar descuento"} theme={"secondary"} onClick={onCancel}  />}
                    <Button disabled={loading || !descuento_seleccionado} className="modal-descuentos__btn" type={"submit"} text={"Aplicar descuento"} theme={"primary"}  />
                </div>
            </form>
        </Modal>
    )
}

export { useStateDescuentos }

export default ModalDescuentos